import { render, staticRenderFns } from "./InterlocuteursList.vue?vue&type=template&id=f53588f0&"
import script from "./InterlocuteursList.vue?vue&type=script&lang=js&"
export * from "./InterlocuteursList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports